import React from "react";
import "./formControls.scss";
import "../formFooter.scss";
import {
	useGetSelectedSectionIndexRecoil,
	useSetSelectedSectionIndexRecoil,
	useGetIsSubmittedRecoil,
} from "../../formDetail.service";
import { useSubmitForm } from "../../formDetail.service";
import { useHistory } from "react-router-dom";
import { PathName } from "../../../../../constants/PathName";
export const FormControls: React.FC = () => {
	const { submitForm, validateForm, addSubmissionsLoading } = useSubmitForm();
	const { selectedSectionIndex, isFirstSection, isLastSection } = useGetSelectedSectionIndexRecoil();
	const { setSelectedSectionIndex } = useSetSelectedSectionIndexRecoil();
	const { isSubmitted } = useGetIsSubmittedRecoil();
	const history = useHistory();

	const handleClose = () => {
		history.push(PathName.DASHBOARD);
	};

	const handlePrevious = () => {
		setSelectedSectionIndex((prev) => prev - 1);
	};

	const handleNext = async () => {
		if (isLastSection) {
			await submitForm();
		} else {
			if (validateForm()) {
				setSelectedSectionIndex((prev) => prev + 1);
			}
		}
	};

	const handleDone = () => {
		history.push(PathName.DASHBOARD);
	};

	return (
		<div className="form-controls">
			<button className="close-navBar" onClick={handleClose}>
				Close
			</button>
			<div className="pre-next">
				{selectedSectionIndex > 0 && !isSubmitted && (
					<button className="previous-navBar" onClick={handlePrevious}>
						Previous
					</button>
				)}
				{isSubmitted ? (
					<button className="done-navBar" onClick={handleDone}>
						Done
					</button>
				) : (
					<button className="next-navBar" onClick={handleNext} disabled={addSubmissionsLoading}>
						{isLastSection ? (addSubmissionsLoading ? "Submitting..." : "Submit") : "Next"}
					</button>
				)}
			</div>
		</div>
	);
};
